import React, { useRef, useState, useEffect } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../../../Config';

const EditBranch = ({parent_id, show, handleClose, onSuccess, MasterID, MasterName ,refresh}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (MasterID && MasterName) {
            formik.setValues({
                id: `${MasterID}`,
                name: MasterName,
            });
        }
    }, [MasterID, MasterName]);
    
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Parent is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            id: `${MasterID}` || '',
            name: MasterName || '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const response = await fetch(
                  `${adminMainUrl}/api/account/branch-master`,
                  {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                      "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
                      user_id: Cookies.get("flexichain_user_id"),
                    },
                    body: JSON.stringify(values),
                  }
                );

                const data = await response.json();

                if (response.ok) {
                    // closeButtonRef.current.click();
                    refresh();
                    if (onSuccess) onSuccess();
                    toast.success(data?.msg);
                    handleClose()
                } else {
                    toast.error(data?.msg);
                }
            } catch (error) {
                console.error('Network error:', error);
            }
            finally {
                setIsSubmitting(false); // Stop the spinner
            }
        },
    });
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Branch </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                            Branch  <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            id="name"
                            name="name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name ? (
                            <div className="error">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Update"}
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditBranch